import React from 'react';

import { Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import SalesProjectionIcon from 'images/icons/arrows/arrowChartLightBlueNoBgOutline.svg';
import CmvIcon from 'images/icons/charts/chartLightBlueNoBgOutline.svg';
import DeleteIcon from 'images/icons/signals/removesAndDeletes/deleteBlancBlue.svg';
import AnalyzeIcon from 'images/menu-items/desktop/analyzeLightBlueNoBgOutline.svg';
import CatalogIcon from 'images/menu-items/desktop/catalogLightBlueNoBgOutline.svg';
import CopilotIcon from 'images/menu-items/desktop/copilotLightBlueNoBgOutline.svg';
import CountIcon from 'images/menu-items/desktop/countLightBlueNoBgOutline.svg';
import MenuIcon from 'images/menu-items/desktop/menuLightBlueNoBgOutline.svg';
import ParametersIcon from 'images/menu-items/desktop/parametersLightBlueNoBgOutline.svg';
import ProductionIcon from 'images/menu-items/desktop/productionLightBlueNoBgOutline.svg';
import ReceivementIcon from 'images/menu-items/desktop/receivementLightBlueNoBgOutline.svg';
import RegisterOrderIcon from 'images/menu-items/desktop/registerOrderLightBlueNoBgOutline.svg';
import TransferIcon from 'images/menu-items/desktop/transferLightBlueNoBgOutline.svg';
import UsersIcon from 'images/menu-items/desktop/usersLightBlueNoBgOutline.svg';
import RestaurantNetworkIcon from 'images/icons/menu-items/restaurantNetwork.svg';

import AdjustGrayIcon from 'images/icons/menu-items/adjustGray.svg';
import CatalogGrayIcon from 'images/icons/menu-items/catalogGray.svg';
import CMVGrayIcon from 'images/icons/menu-items/cmvGray.svg';
import ConfigGrayIcon from 'images/icons/menu-items/configGray.svg';
import CountGrayIcon from 'images/icons/menu-items/countGray.svg';
import DiscardGrayIcon from 'images/icons/menu-items/discardGray.svg';
import MenuGrayIcon from 'images/icons/menu-items/menuGray.svg';
import OrderGrayIcon from 'images/icons/menu-items/orderGray.svg';
import ProjectionSalesGrayIcon from 'images/icons/menu-items/projectionSalesGray.svg';
import ReciveGrayIcon from 'images/icons/menu-items/reciveGray.svg';
import RightGrayIcon from 'images/icons/menu-items/rightGray.svg';
import SubMepGrayIcon from 'images/icons/menu-items/subMepGray.svg';
import ProductionsGrayIcon from 'images/icons/menu-items/productionGray.svg';
import TransferGrayIcon from 'images/icons/menu-items/transferGray.svg';
import UsersGrayIcon from 'images/menu-items/desktop/usersGrayNoBgOutline.svg';
import RestaurantNetworkGrayIcon from 'images/icons/menu-items/restaurantNetworkGray.svg';
import PrinterSubBlueIcon from 'images/icons/menu-items/printerSubBlue.svg';
import PrinterSubGrayIcon from 'images/icons/menu-items/printerSubGray.svg';

import MiseEnPlaceIcon from 'images/menu-items/miseEnPlace.svg';

import './styles.scss';
import { clearFilter as clearFilterCard } from 'store/reducers/cardsFilterSlice';
import { clearFilter as clearFilterCount } from 'store/reducers/countFilterSlice';
import { clearFilter as clearFilterProduction } from 'store/reducers/productionsFilterSlice';
import { clearFilter as clearFilterProduct } from 'store/reducers/productsFilterSlice';

function HoverItems({
  restaurantId = 0,
  currentRole = {},
  setOpenHover = () => {},
  reference = null,
  confirmModal,
  setConfirmModal,
  storedQuotationProductsSelected,
  isQuotationPage,
  handleCustomOnClick
}) {
  const dispatch = useDispatch();
  const showJustLabel =
    currentRole?.subs?.length === 0 && currentRole?.name != 'print';
  const openConfirmationDialog =
    storedQuotationProductsSelected?.length && isQuotationPage;

  const clearLocalStorageFilters = () => {
    localStorage.removeItem('cardId');
    localStorage.removeItem('productId');
    dispatch(clearFilterCard());
    dispatch(clearFilterCount());
    dispatch(clearFilterProduction());
    dispatch(clearFilterProduct());
  };

  const handleRedirect = (pathName) => {
    setConfirmModal({
      ...confirmModal,
      name: 'quotation',
      open: true,
      redirectPath: pathName,
      confirmText: 'Sim',
      cancelText: 'Não',
      content: (
        <Typography className="bold">
          Você perderá todos os itens selecionados, deseja continuar?
        </Typography>
      )
    });
  };

  const renderIcon = (item, active = true) => {
    let currentIcon = CatalogIcon;

    if (item === 'cataloguing') {
      currentIcon = active == false ? CatalogGrayIcon : CatalogIcon;
    }

    if (item === 'print') {
      currentIcon = active == false ? PrinterSubGrayIcon: PrinterSubBlueIcon;
    }

    if (item === 'menu') {
      currentIcon = active == false ? MenuGrayIcon : MenuIcon;
    }

    if (item === 'cmv') {
      currentIcon = active == false ? CMVGrayIcon : CmvIcon;
    }

    if (item === 'cmvNetwork') {
      currentIcon = active == false ? RestaurantNetworkGrayIcon : RestaurantNetworkIcon;
    }

    if (item === 'salesProjections') {
      currentIcon =
        active == false ? ProjectionSalesGrayIcon : SalesProjectionIcon;
    }

    if (item === 'receipts') {
      currentIcon = active == false ? ReciveGrayIcon : ReceivementIcon;
    }

    if (item === 'progDiaryCounts' || item === 'progDiary') {
      currentIcon = active == false ? RightGrayIcon : AnalyzeIcon;
    }

    if (item === 'counts') {
      currentIcon = active == false ? CountGrayIcon : CountIcon;
    }

    if (item === 'transfers') {
      currentIcon = active == false ? TransferGrayIcon : TransferIcon;
    }

    if (item === 'newOrder') {
      currentIcon = active == false ? OrderGrayIcon : RegisterOrderIcon;
    }

    if (item === 'copilot') {
      currentIcon = active == false ? ConfigGrayIcon : CopilotIcon;
    }

    if (item === 'miseEnPlace') {
      currentIcon = active == false ? SubMepGrayIcon : MiseEnPlaceIcon;
    }

    if (item === 'productions') {
      currentIcon = active == false ? ProductionsGrayIcon : ProductionIcon;
    }

    if (item === 'parameters') {
      currentIcon = active == false ? AdjustGrayIcon : ParametersIcon;
    }

    if (item === 'users') {
      currentIcon = active == false ? UsersGrayIcon : UsersIcon;
    }

    if (item === 'stockLosses') {
      currentIcon = active == false ? DiscardGrayIcon : DeleteIcon;
    }

    return (
      <img
        className="mr8"
        style={{ width: '16px', height: '16px' }}
        src={currentIcon}
        alt={currentIcon}
      />
    );
  };

  return (
    <div
      className={`onHoverSideBar ${currentRole?.name}`}
      onMouseLeave={() => setOpenHover(false)}
      ref={reference}
      id="hoverItemSideBar"
    >
      <div className="onHoverSideBarHeader">
        {currentRole.subs?.length === 0 ? (
          <Link
            className="hoverItemTitle"
            onClick={(e) => {
              if (!e.ctrlKey) {
                clearLocalStorageFilters();
              }
            }}
            to={`${
              currentRole.url !== '' ? `/${currentRole.url}` : ''
            }/${restaurantId}`}
          >
            {currentRole?.label}
          </Link>
        ) : (
          <Typography className="hoverItemTitle">
            {currentRole?.label}
          </Typography>
        )}
      </div>

      {!showJustLabel &&
        currentRole.subs &&
        currentRole?.subs?.map((subtitle) => (
          <Link
            className={`${
              subtitle.active == false
                ? 'hoverItemInactiveDefault'
                : `hoverItemDefault`
            } ${
              subtitle.active == false && subtitle?.showIcon
                ? ''
                : subtitle?.showIcon
                ? 'lightBlue'
                : 'topDivider'
            }`}
            onClick={(e) => {
              if (subtitle?.openModal) {
                handleCustomOnClick(subtitle);
              }

              if (!e.ctrlKey) {
                clearLocalStorageFilters();
              }

              if (openConfirmationDialog) {
                handleRedirect(`/${subtitle.url}/${restaurantId}`);
              }
            }}
            to={
              !openConfirmationDialog &&
              !subtitle?.openModal &&
              `${subtitle.url ? `/${subtitle.url}` : ''}/${restaurantId}`
            }
          >
            <div className="dFlex alignCenter noBg w100 flexRow justifyStart">
              {subtitle?.showIcon &&
                renderIcon(subtitle?.name, subtitle?.active)}

              <span>{subtitle?.label}</span>
            </div>
          </Link>
        ))}
    </div>
  );
}

export default HoverItems;
